module.exports = __webpack_public_path__ + "static/media/logo169.05be5d48.png";